export {
  ACE_DB_DATE_FORMAT_STRING,
  aceDBDateToWebSdkDate,
  aceWebApiDateToWebSdkDate,
  isValidAceDBDate,
  isValidAceWebApiDate,
  isValidWebSdkDate,
  webSdkDateToAceDBDate,
  webSdkDateToAceWebApiDate,
} from './aceDate';
export { callWS, getTextFile, sendAjaxRestRequest } from './ajaxc';
export { getConfig, setConfig } from './config';
export {
  addTimeToDate,
  dateToShortDateString,
  isValidDate,
  now,
  setTimeToStartOfDay,
} from './dateUtils';
export { loadCSS, loadJS, splitPathAndFilename } from './fileUtils';
export { getLang, setLang, setupLanguage } from './lang';
export { load, loadJs } from './loadISFiles';
export { deepClone } from './objectUtils';
export {
  isString,
  isDate,
  isDefined,
  isInteger,
  isNullOrUndefined,
  isNumber,
  isObject,
  isUndefined,
} from './typeUtils';
export { createUUID, createUUIDWithBuiltinCryptoLibrary } from './uuidUtils';
// export {
//   messageHandler,
//   removeWebSocketProtocolFromUrl,
//   wsBinaryType,
//   wsCheck,
//   wsClose,
//   wsNew,
//   wsOnClose,
//   wsOnError,
//   wsOnMessage,
//   wsOnOpen,
//   wsSend,
// } from './webSocket';
// note: glöm ej fixa websocket jonas!!!!
export * as webSocket from './webSocket';
export { getUrlParam, getUrlVars, isUri, parseUri, isValidUrl } from './webUtils';
export { doNotTrack } from './doNotTrack';
export { TextManager } from './textManager';
export { getACEObject } from './getACEObject';
export { getLocation } from './browser';
